(function () {
  "use strict";
  var root = document.querySelector("[data-dztp]");
  if (!root) return;
  var D;
  try { D = JSON.parse(root.querySelector("[data-dztp-dati]").textContent); } catch (e) { return; }
  function $(s) { return root.querySelector(s); }
  function $$(s) { return Array.prototype.slice.call(root.querySelectorAll(s)); }
  var MESI = ["gennaio","febbraio","marzo","aprile","maggio","giugno","luglio","agosto","settembre","ottobre","novembre","dicembre"];
  var oggi = new Date().toISOString().slice(0, 10);

  function soldi(c) {
    var n = Math.round(c / 100), s = String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return "€ " + s;
  }
  function stato(v) {
    if (!v) return { k: "nd", t: "Non esiste", c: "var(--rq)" };
    if (v.disp) return { k: "pr", t: "Pronta consegna", corto: "Pronta", c: "var(--pr)" };
    if (v.arr && v.arr >= oggi) {
      var m = MESI[+v.arr.slice(5, 7) - 1], a = v.arr.slice(0, 4);
      return { k: "ar", t: "In arrivo · " + m + " " + a, corto: m.slice(0, 3) + " " + a.slice(2), mese: m + " " + a, c: "var(--ar)" };
    }
    return { k: "rq", t: "Su richiesta", corto: "Su richiesta", c: "var(--rq)" };
  }
  var PESO = { pr: 0, ar: 1, rq: 2, nd: 3 };
  function pesoTg(t) { var n = parseFloat(String(t).replace(",", ".")); return isNaN(n) ? 999 : n; }

  var V = D.varianti, IC = D.ic, IT = D.it;
  var colori = [], taglie = [];
  V.forEach(function (v) {
    if (colori.indexOf(v.o[IC]) < 0) colori.push(v.o[IC]);
    if (taglie.indexOf(v.o[IT]) < 0) taglie.push(v.o[IT]);
  });
  taglie.sort(function (a, b) { return pesoTg(a) - pesoTg(b); });
  function trova(c, t) { return V.filter(function (v) { return v.o[IC] === c && v.o[IT] === t; })[0] || null; }
  function migliore(lista) {
    return lista.slice().sort(function (a, b) {
      var d = PESO[stato(a).k] - PESO[stato(b).k];
      if (d) return d;
      return (a.arr || "9") < (b.arr || "9") ? -1 : 1;
    })[0];
  }
  // colori ordinati: prima quelli pronti, poi in arrivo, poi su richiesta
  colori.sort(function (a, b) {
    var ma = migliore(V.filter(function (v) { return v.o[IC] === a; })), mb = migliore(V.filter(function (v) { return v.o[IC] === b; }));
    return PESO[stato(ma).k] - PESO[stato(mb).k];
  });

  // conteggi in apertura
  $("[data-dztp-n-pr]").textContent = V.filter(function (v) { return stato(v).k === "pr"; }).length;
  $("[data-dztp-n-ar]").textContent = V.filter(function (v) { return stato(v).k === "ar"; }).length;

  // scelta iniziale: la variante dell'indirizzo, altrimenti la prima pronta, poi la prima in arrivo
  var u = new URLSearchParams(location.search).get("variant");
  var v0 = V.filter(function (v) { return String(v.id) === u; })[0] || migliore(V);
  var col = v0.o[IC], tg = v0.o[IT], kit = "";

  // disegna i colori
  var boxCol = $("[data-dztp-colori]");
  colori.forEach(function (c) {
    var lista = V.filter(function (v) { return v.o[IC] === c; });
    var conImg = lista.filter(function (v) { return v.mini; })[0];
    var s = stato(migliore(lista));
    var b = document.createElement("button");
    b.type = "button"; b.className = "dztp-col"; b.setAttribute("data-c", c); b.setAttribute("role", "radio");
    b.innerHTML = (conImg ? '<img src="' + conImg.mini + '" alt="" loading="lazy" width="180" height="135">' : "") +
      '<span></span><i class="dztp-dot ' + s.k + '" title="' + s.t + '"></i>';
    b.querySelector("span").textContent = c;
    b.addEventListener("click", function () {
      col = c;
      if (!trova(col, tg)) { var m = migliore(lista); tg = m.o[IT]; }
      else {
        var att = trova(col, tg);
        // se in questo colore la taglia scelta non c'e' pronta ma un'altra si', resta sulla taglia (lo stato lo dice)
        if (!att) tg = migliore(lista).o[IT];
      }
      aggiorna();
    });
    boxCol.appendChild(b);
  });

  var boxTg = $("[data-dztp-taglie]");
  function disegnaTaglie() {
    boxTg.innerHTML = "";
    taglie.forEach(function (t) {
      var v = trova(col, t), s = stato(v);
      var b = document.createElement("button");
      b.type = "button"; b.className = "dztp-tg" + (v ? "" : " nd") + (t === tg ? " on" : "");
      b.setAttribute("role", "radio"); b.setAttribute("aria-checked", t === tg ? "true" : "false");
      b.innerHTML = "<b></b><small><i></i><em></em></small>";
      b.querySelector("b").textContent = t;
      b.querySelector("i").style.setProperty("--c", s.c);
      b.querySelector("em").textContent = v ? s.corto : "—";
      b.querySelector("em").style.fontStyle = "normal";
      if (!v) { b.disabled = true; b.title = "Non disponibile in questo colore"; }
      b.addEventListener("click", function () { tg = t; aggiorna(); });
      boxTg.appendChild(b);
    });
  }

  var foto = $("[data-dztp-foto]");
  function kitScelto() { return D.kit.filter(function (k) { return k.id === kit; })[0] || null; }

  function aggiorna() {
    var v = trova(col, tg), s = stato(v), k = kitScelto();
    $$(".dztp-col").forEach(function (b) {
      var on = b.getAttribute("data-c") === col; b.classList.toggle("on", on); b.setAttribute("aria-checked", on ? "true" : "false");
    });
    disegnaTaglie();
    $("[data-dztp-l-col]").textContent = col;
    $("[data-dztp-l-tg]").textContent = tg ? "Taglia " + tg : "";

    // foto grande
    var img = (v && v.img) || (V.filter(function (x) { return x.o[IC] === col && x.img; })[0] || {}).img;
    if (foto && img && foto.getAttribute("src") !== img) {
      foto.classList.add("cambia");
      var pre = new Image();
      pre.onload = pre.onerror = function () { foto.src = img; requestAnimationFrame(function () { foto.classList.remove("cambia"); }); };
      pre.src = img;
    }
    $("[data-dztp-s-col]").textContent = col;
    var bd = $("[data-dztp-s-badge]"); bd.textContent = s.t; bd.style.setProperty("--c", s.c);

    // stato della combinazione
    var st = $("[data-dztp-stato]");
    st.style.setProperty("--c", s.c);
    if (s.k === "pr") st.innerHTML = "<b>Pronta consegna.</b> Questo telaio è disponibile: lo ordini online e lo prepariamo subito.";
    else if (s.k === "ar") st.innerHTML = "<b>In arrivo a " + s.mese + ".</b> Non si acquista ancora online: scrivici per prenotarlo, te lo teniamo da parte appena arriva.";
    else if (s.k === "rq") st.innerHTML = "<b>Su richiesta.</b> Questa combinazione si ordina a Pinarello: contattaci e ti diciamo i tempi di consegna.";
    else st.textContent = "";

    // riepilogo
    var tKit = kit === "su-misura" ? "Su misura (preventivo)" : (k ? k.titolo + (k.prodotto ? "" : " (preventivo)") : "Solo telaio");
    var tot = (v ? v.prezzo : 0) + (k && k.prodotto ? k.prodotto.prezzo : 0);
    var aPrev = kit === "su-misura" || (k && !k.prodotto);
    $("[data-dztp-r-col]").textContent = col;
    $("[data-dztp-r-tg]").textContent = tg || "—";
    $("[data-dztp-r-stato]").textContent = s.t;
    $("[data-dztp-r-kit]").textContent = tKit;
    $("[data-dztp-tot]").textContent = soldi(tot) + (aPrev ? " + montaggio" : "");
    $("[data-dztp-tot2]").textContent = soldi(tot);
    $("[data-dztp-bar-v]").textContent = col + " · " + (tg || "—") + " · " + tKit;
    $$(".dztp-kit").forEach(function (l) { l.classList.toggle("on", !!l.querySelector("input:checked")); });

    // pulsante: si compra solo il telaio pronto; il resto passa da WhatsApp
    var cta = $("[data-dztp-cta]");
    var compra = v && s.k === "pr" && !aPrev && !(k && k.prodotto && !k.prodotto.disp);
    cta.classList.toggle("wa", !compra);
    if (compra) cta.textContent = "Aggiungi al carrello";
    else if (aPrev) cta.textContent = "Chiedi il preventivo";
    else if (s.k === "ar") cta.textContent = "Prenotalo su WhatsApp";
    else cta.textContent = "Chiedi disponibilità";
    cta.setAttribute("data-modo", compra ? "carrello" : "wa");

    var msg = "Ciao! Mi interessa il telaio " + D.titolo + "\nColore: " + col + "\nTaglia: " + tg + "\nDisponibilità sul sito: " + s.t + "\nMontaggio: " + tKit;
    var note = $("[data-dztp-note]").value.trim();
    if (note) msg += "\nNote: " + note;
    cta.setAttribute("data-wa", "https://wa.me/" + D.wa + "?text=" + encodeURIComponent(msg));

    if (v && history.replaceState) {
      var url = new URL(location.href); url.searchParams.set("variant", v.id); history.replaceState(null, "", url);
    }
  }

  $$('input[name="dztp-kit"]').forEach(function (r) { r.addEventListener("change", function () { kit = r.value; aggiorna(); }); });
  $("[data-dztp-note]").addEventListener("input", aggiorna);

  // guida alle taglie: apre le geometrie della sezione Dettagli Pinarello
  var geo = $("[data-dztp-geo]");
  geo.addEventListener("click", function (e) {
    e.preventDefault();
    var d = document.querySelector(".dzp-det");
    if (d) { d.open = true; d.scrollIntoView({ behavior: "smooth", block: "start" }); }
    else window.open("https://wa.me/" + D.wa, "_blank", "noopener");
  });

  $("[data-dztp-cta]").addEventListener("click", function () {
    var cta = this, err = $("[data-dztp-err]");
    if (cta.getAttribute("data-modo") === "wa") { window.open(cta.getAttribute("data-wa"), "_blank", "noopener"); return; }
    var v = trova(col, tg), k = kitScelto();
    if (!v) return;
    var props = { "Montaggio": k ? k.titolo : "Solo telaio" };
    var note = $("[data-dztp-note]").value.trim();
    if (note) props["Note per l'officina"] = note;
    var items = [{ id: v.id, quantity: 1, properties: props }];
    if (k && k.prodotto) items.push({ id: k.prodotto.id, quantity: 1, properties: { "Montato su": D.titolo + " · " + col + " · " + tg } });
    cta.disabled = true; cta.textContent = "Aggiungo…"; err.hidden = true;
    fetch(D.aggiungi, { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || "errore"); return j; }); })
      .then(function () { location.href = D.carrello; })
      .catch(function (x) { err.textContent = "Non siamo riusciti ad aggiungere al carrello (" + x.message + "). Riprova o scrivici su WhatsApp."; err.hidden = false; cta.disabled = false; aggiorna(); });
  });

  var testa = document.querySelector(".dz header") || document.querySelector("header");
  function misura() { if (testa) root.style.setProperty("--dztp-testa", (testa.getBoundingClientRect().height + 8) + "px"); }
  misura(); addEventListener("resize", misura);

  aggiorna();
})();

/* clic sul telaio: si apre a tutto schermo in Full HD (1920 px al massimo).
   Si chiude toccando ovunque, con la X o con Esc. */
(function () {
  var root = document.querySelector("[data-dztp]");
  if (!root) return;
  var foto = root.querySelector("[data-dztp-foto]");
  if (!foto) return;
  foto.style.cursor = "zoom-in";
  foto.setAttribute("title", "Clicca per ingrandire");
  var box = document.createElement("div");
  box.className = "dztp-zoom";
  box.setAttribute("role", "dialog");
  box.setAttribute("aria-label", "Telaio ingrandito");
  box.hidden = true;
  box.innerHTML = '<button type="button" class="dztp-zoom-x" aria-label="Chiudi">×</button><img alt="">';
  document.body.appendChild(box);
  var big = box.querySelector("img");
  function hd(u) {
    if (!u) return u;
    return /[?&]width=\d+/.test(u) ? u.replace(/([?&])width=\d+/, "$1width=1920") : u + (u.indexOf("?") > -1 ? "&" : "?") + "width=1920";
  }
  function apri() {
    big.src = hd(foto.currentSrc || foto.src);
    big.alt = foto.alt || "";
    box.hidden = false;
    document.documentElement.style.overflow = "hidden";
    requestAnimationFrame(function () { box.classList.add("on"); });
  }
  function chiudi() {
    box.classList.remove("on");
    document.documentElement.style.overflow = "";
    setTimeout(function () { box.hidden = true; big.removeAttribute("src"); }, 250);
  }
  foto.addEventListener("click", apri);
  box.addEventListener("click", chiudi);
  addEventListener("keydown", function (e) { if (e.key === "Escape" && !box.hidden) chiudi(); });
})();
